import { createSimplePageStrategy } from './simple-page.strategy-helper';

export const RewardPointsSeoStrategy = createSimplePageStrategy(
  'rewardPoints',
  'reward-points',
  '/reward-points'
);
